import { MutationTree } from "vuex";
import { VenueState } from "@/types/store/clientzone";
import Vue from "vue";

export const mutations: MutationTree<VenueState> = {
  SET_VENUES: (state, payload) => Vue.set(state, 'venues', payload),
  SET_ALL_VENUES: (state, payload) => Vue.set(state, 'allVenues', payload),
}
